import { render, staticRenderFns } from "./NotificationsPanel.htm?vue&type=template&id=2cd32af2&scoped=true&"
import script from "./NotificationsPanel.ts?vue&type=script&lang=js&"
export * from "./NotificationsPanel.ts?vue&type=script&lang=js&"
import style0 from "./NotificationsPanel.scss?vue&type=style&index=0&id=2cd32af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd32af2",
  null
  
)

export default component.exports